"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _constants = require("../utils/constants");

var _utils = require("../utils/utils");

var _default = {
  title: 'Responsive Type',
  isRelevant: function isRelevant(styleParams) {
    return styleParams.isVertical;
  },
  type: _constants.INPUT_TYPES.OPTIONS,
  "default": _constants.GALLERY_CONSTS.gridStyle.FIT_TO_SCREEN,
  options: (0, _utils.createOptions)('gridStyle'),
  description: "Choose between adjusting the number of columns addording to the container\n  size or setting it manualyand keep it fixed.\n  "
};
exports["default"] = _default;